<!-- 技术优势 -->
<template>
    <div class="container">
        <div class="section">
            <div class="label">深耕技术，为发展注入创新动能</div>
            <div class="content">
                <div class="item"
                     v-for="(item,index) in panelList"
                     :key="index"
                >
                    <img class="image" :src="item.img" alt/>
                    <div>
                        <div class="label">{{ item.label }}</div>
                        <div class="title">{{ item.title }}</div>
                        <div class="line"></div>
                        <div class="text">{{ item.text }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'technicalAdvantage',
    data() {
        return {
            panelList: [
                {
                    label: '18项',
                    title: '发明专利',
                    text: '截止目前公司已成功申报18项发明专利，另6项正在申报中',
                    img: require('@/assets/image/choiceYC/technicalAdvantage/fmzl.png')
                },
                {
                    label: '46项',
                    title: '著作权',
                    text: '截止目前已成功申报46项软件著作权',
                    img: require('@/assets/image/choiceYC/technicalAdvantage/zzq.png')
                },
                {
                    label: '16项',
                    title: '病害分析核心算法',
                    text: '自主创新研发AI智能巡检系统，能自动识别路面16大类病害，准确率可达92%',
                    img: require('@/assets/image/choiceYC/technicalAdvantage/hxsf.png')
                },
                {
                    label: '大数据',
                    title: '大数据多维分析技术',
                    text: '综合多源海量数据，融合多组核心算法，提供科学决策',
                    img: require('@/assets/image/choiceYC/technicalAdvantage/dsj.png')
                }
            ]
        };
    },
    mounted() {

    },
    methods: {},
};
</script>

<style lang='scss' scoped>
.container {
    height: 100%;
    width: 100%;

    .section {
        padding: 100px 0;

        .label {
            font-size: 28px;
            text-align: center;
        }

        .content {
            margin: 0 auto;
            width: 1080px;
            padding: 50px 0;
            display: flex;
            justify-content: space-between;

            .item {
                width: 184px;
                padding: 24px 32px;
                background: linear-gradient(180deg, #f3f9ff 0%, #ffffff 100%);
                box-shadow: 0 3px 18px 1px rgba(26, 102, 187, 0.18);
                border-radius: 4px;
                border: 2px solid #ffffff;

                .image {
                    width: 100px;
                    height: 110px;
                }

                .label {
                    text-align: left;
                    font-size: 30px;
                    font-weight: bold;
                    color: #0079fe;
                    margin-top: 16px;
                }

                .title {
                    font-size: 20px;
                    line-height: 28px;
                    margin-top: 16px;
                }

                .line {
                    margin: 16px 0;
                    height: 2px;
                    width: 15%;
                    background: #0079FE;
                    transition: all 0.3s;
                }

                .text {
                    font-size: 16px;
                    line-height: 22px;
                    text-align: justify;
                }

                &:hover {
                    background: #ffffff;

                    .line {
                        width: 25%;

                    }
                }
            }
        }
    }
}

@import "./style.scss";
</style>
